export default __webpack_public_path__ + "static/media/delivery_service.edea1a58.PNG";